// extracted by mini-css-extract-plugin
module.exports = {"tableOfContents":"Innholdsfortegnelse_tableOfContents__wtIHj"};